import { sendRequest } from 'lib/apis/core';
import { useQuery } from 'react-query';
import { AdsEndPoints, AdsType } from './index';

//new services
export const getBanners = (params: AdsType.GetBannersRequestType) =>{
  return sendRequest<AdsType.GetBannersResponseType>({
    method: 'get',
    url: AdsEndPoints.GET_BANNER_NEW_VERSION,
    config:{
      params
    }
  })

}
export const useGetBannerQuery = (params: AdsType.GetBannersRequestType) =>{
  return useQuery([AdsEndPoints.SIDE_DECK_BANNER,params],()=>{
    return getBanners(params).then((res)=>res.data)
  })
}

//
// export const getSideDeckBaners = (params: AdsType.SideDeckReqeust) => {
//   return sendRequest<AdsType.SideDeckResponse>({
//     method: 'post',
//     body: params,
//     url: AdsEndPoints.SIDE_DECK_BANNER,
//   });
// };

// export const useGetSideDeckBanersQuery = (params: AdsType.SideDeckReqeust) => {
//   return useQuery([AdsEndPoints.SIDE_DECK_BANNER, params], () =>
//     getSideDeckBaners(params).then((res) => res.data)
//   );
// };

export const getWithinPostBaners = (params: AdsType.WithInPostReqeust) => {
  return sendRequest<AdsType.WithInPostResponse>({
    method: 'post',
    body: params,
    url: AdsEndPoints.WITHIN_POST_BANNER,
  });
};

export const useGetWithinPostBaners = (params: AdsType.WithInPostReqeust) => {
  return useQuery([AdsEndPoints.WITHIN_POST_BANNER, params], () =>
    getWithinPostBaners(params).then((res) => res.data)
  );
};

export const impressionBanner = (params: AdsType.ImpressionRequest) => {
  return sendRequest<null>({
    method: 'post',
    body: params,
    url: AdsEndPoints.IMPRESSION_MULTI,
  });
};

export const useImpressionBanner = (params: AdsType.ImpressionRequest) => {
  return useQuery([AdsEndPoints.IMPRESSION_MULTI, params], () =>
    impressionBanner(params).then((res) => res.data)
  );
};
